import { render, staticRenderFns } from "./CotacaoFreteSolicitacoes.vue?vue&type=template&id=22ce74e3"
import script from "./CotacaoFreteSolicitacoes.vue?vue&type=script&lang=js"
export * from "./CotacaoFreteSolicitacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports